import { useEffect, useState } from 'react';
import { parseRoute, type Route } from './lib/route.js';
import { SplashScreen } from './screens/SplashScreen.js';
import { CreateScreen } from './screens/CreateScreen.js';
import { JoinScreen } from './screens/JoinScreen.js';
import { LobbyScreen } from './screens/LobbyScreen.js';
import { GameScreen } from './screens/GameScreen.js';
import { HelpScreen } from './screens/HelpScreen.js';

export function App(): React.JSX.Element {
  const [route, setRoute] = useState<Route>(() => parseRoute(window.location.hash));

  useEffect(() => {
    const onHash = () => setRoute(parseRoute(window.location.hash));
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  switch (route.name) {
    case 'splash':
      return <SplashScreen />;
    case 'create':
      return <CreateScreen />;
    case 'join':
      return <JoinScreen prefilledCode={route.code} />;
    case 'lobby':
      return <LobbyScreen code={route.code} />;
    case 'game':
      return <GameScreen code={route.code} />;
    case 'help':
      return <HelpScreen />;
  }
}
